import { AvatarBlock, Link } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { useUiStateContext } from '@frontend/utils/hooks/useUiState';
import type { IPractitioner } from '../../interfaces/practitioner';
import { getDisplayInitials } from '../../../../common/utils/getDisplayInitials';
import { getDisplayName } from '../../../../common/utils/getDisplayName';
import { useAbortableFetch } from '../../../utils/hooks/useAbortableFetch';

export interface IPaymentsNavigationProps {
    practitionerId: string;
    size: 'large' | 'small';
}

export function PaymentsProfile(props: IPaymentsNavigationProps) {
    const abortableFetch = useAbortableFetch();
    const [practitioner, setPractitioner] = useState<IPractitioner>();
    const { uiState, dispatchUiStateAction } = useUiStateContext();

    useEffect(() => {
        loadPractitioner();
    }, [props.practitionerId]);

    function handleLinkClick(event: React.MouseEvent<HTMLElement, MouseEvent>) {
        event.stopPropagation();
        if (uiState.isTopBarOpen) {
            dispatchUiStateAction({ type: 'setIsTopBarOpen', isTopBarOpen: false });
        }
    }

    return (
        <AvatarBlock
            backgroundColor="white"
            imageUrl={practitioner?.profilePictureUrl}
            initials={practitioner && getDisplayInitials(practitioner)}
            size={props.size}
            title={
                <Link
                    color="subtle"
                    fontWeight="medium"
                    onClick={handleLinkClick}
                    textAlign={props.size === 'large' ? 'center' : undefined}
                    to={`/practitioners/${props.practitionerId}/profile`}
                    variant="link"
                >
                    {practitioner && getDisplayName(practitioner)}
                </Link>
            }
        />
    );

    async function loadPractitioner() {
        const result = await abortableFetch.getJson(`/api/practitioners/${props.practitionerId}`);
        setPractitioner(result.json);
    }
}
